import React from "react";
import "./Hero.css";
import heroimg from '../../assets/easter-flowers-hero.webp'

export default function Hero({ onPrimaryClick }) {
  return (
    <section className="hero" aria-label="Flower delivery hero">
      <div className="hero__inner">
        {/* Left: Copy */}
        <div className="hero__copy">
          <p className="hero__eyebrow">Fresh • Hand-tied • Same-day</p>

          <h1 className="hero__title">
            Send love in every <span>petal</span>
          </h1>

          <p className="hero__subtitle">
            Premium bouquets crafted by local florists and delivered with care.
            Surprise someone today with blooms that speak from the heart.
          </p>

          <div className="hero__ctas">
            <button
              className="hero-cta-btn"
              type="button"
              onClick={onPrimaryClick}
              aria-label="Shop bouquets now"
            >
              Shop Bouquets
            </button>

            <button className="hero__btn--ghost" type="button">
              View Collections
            </button>
          </div>

          <ul className="hero__points" aria-label="Benefits">
            <li>✨ Hand-tied by expert florists</li>
            <li>🚚 Same-day delivery</li>
            <li>💌 Free personalized note</li>
          </ul>
        </div>

        {/* Right: Image */}
        <div className="hero__media">
          <img
            className="hero__img"
            src={heroimg}
            alt="Elegant pink and white bouquet arrangement"
            loading="eager"
            decoding="async"
          />
          {/* Decorative blush blob */}
          <span className="hero__blob" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
}
